import React from 'react';
import './Footer.css';
import { Button } from './Button';
import { Link } from 'react-router-dom';

function Footer() {
    return (
        <div className='footer-container'>
            <section class='social-media'>
                <div class='social-media-wrap'>
                    <div class='footer-logo'>
                        <Link to='/' className='social-logo'>Gentille Things</Link>
                    </div>
                    <div class='social-icons'>
                        <Link class='social-icon-link facebook' to='/' target='_blank' aria-label='Facebook'>
                            <i class='fab fa-facebook-f' />
                        </Link>
                        <Link class='social-icon-link instagram' to='/' target='_blank' aria-label='Instagram'>
                            <i class='fab fa-instagram' />
                        </Link>
                        <Link class='social-icon-link twitter' to='/' target='_blank' aria-label='Twitter'>
                            <i class='fab fa-twitter' />
                        </Link>
                    </div>
                    <small class='website-rights'>FLYNC © 2023</small>
                </div>
            </section>
        </div>
    );
}

export default Footer;